import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { useStateContext } from "../../global-context/useGlobalContext";

const HowSection = () => {
  const { language } = useStateContext();
  return (
    <HowWrapper>
      <HowText>
        <h1>{language ? <span>Comment?</span> : <span>How?</span>}</h1>
        {language ? (
          <p>
            Avec la technologie qui continue de se déplacer à vitesse grand V,
            inutile de vous dire qu’avoir une présence sur internet amène une
            nouvelle visibilité. Web designer et graphique designer, nous vous
            aidons à avoir une meilleure communication, pour présenter les
            services et les produits de votre entreprise. Votre identité
            visuelle a une grande importance, en ligne ou imprimée sur des
            supports papier, elle reflètera votre image. Créatifs dans l'âme,
            nous serons à l'écoute pour faire naître votre projet.
          </p>
        ) : (
          <p>
            Technology is moving as fast as we can blink. Needless to say,
            having a presence on the web gives you a newfound visibility. Web
            designer and graphic designer, we help you develop better
            communication, to present your business' services and products. Your
            visual identity is crucial, online or printed on paper, it
            represents your company's image. Creatives at heart, we will support
            your project all the way.{" "}
          </p>
        )}
      </HowText>
      <RightSpace></RightSpace>
    </HowWrapper>
  );
};

export default HowSection;

const HowWrapper = styled(motion.div)`
  flex: 1;
  width: 100vw;
  height: 100vh;
  padding: 0 10vw;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: none;
  color: white;
  h1 {
    font-size: 3rem;
    color: #83c5be;
  }
  p {
    font-size: 1.5rem;
    padding-top: 4rem;
    padding-bottom: 3vh;
    line-height: 150%;
  }
  @media (max-width: 950px) {
    padding: 10rem 2.5rem;
    height: fit-content;
  }
`;
const HowText = styled.div`
  flex: 1;
  @media (max-width: 950px) {
    flex: 2;
  }
`;

const RightSpace = styled.div`
  flex: 1;
  @media (max-width: 950px) {
    flex: 0;
  }
`;
